module.exports = __webpack_public_path__ + "img/ruffle_width.3e9985da.png";